import React, { useState } from "react";
import { useUscSelector } from "../../../../redux/store";
import { UscLabel, useUscLabel } from "../../../../utils/labels";
import AccessoryItem from "./AccessoryItem";
import Text from "../../../../../shared-components/toyota/styles/atoms/Text";
import * as Styles from "./Accessories.styles";
import Button from "../../../../../shared-components/toyota/styles/atoms/Button";
import Icon from "../../../../../shared-components/toyota/styles/atoms/Icon";

const Accessories = (): JSX.Element | null => {
    const titleLabel = useUscLabel("uscPdpAccessoriesTitle");
    const accessories = useUscSelector((state) => state.accessories.accessoryResults);
    const [showAll, setShowAll] = useState(false);

    if (!accessories.length) return null;

    const displayedAccessories = showAll ? accessories : accessories.slice(0, 4);

    return (
        <Styles.Wrapper>
            <Text tag="h3" variant="h6">
                {titleLabel}
            </Text>
            <Styles.Grid>
                {displayedAccessories.map((accessory, index) => (
                    <AccessoryItem key={accessory.id} accessory={accessory} index={index} />
                ))}
            </Styles.Grid>
            {accessories.length > 4 && (
                <Button variant="icon-text" onClick={() => setShowAll(!showAll)}>
                    <UscLabel label={showAll ? "uscPdpAccessoriesShowLess" : "uscPdpAccessoriesShowAll"} />
                    <Icon variant={showAll ? "chevron-up" : "chevron-down"} />
                </Button>
            )}
        </Styles.Wrapper>
    );
};

export default Accessories;
